import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const RequestBooking = loadable(() => import(/* webpackChunkName: "RequestBooking" */ './RequestBooking'), {
  fallback: <LoadableFallback visible />,
});

const asyncRequestBooking = ({ route }) => (
  <RequestBooking route={route} />
);

asyncRequestBooking.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncRequestBooking;
